import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { cn } from 'cn';
import { useId } from 'react';

import { isFieldRequired, unique } from '@vestigas/utils';

import { ValidationError } from '@vestigas/ui/molecules';

import { useFieldContext } from './form-context';
import { InputLabel } from './InputLabel';

type RadioOption = {
  readonly label: string;
  readonly value: string;
};

type P = {
  readonly hint?: string;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly options: RadioOption[];
} & ComponentStyling;

export const RadioGroupField = ({
  className,
  hint,
  isDisabled = false,
  label,
  options,
  style,
}: P) => {
  const field = useFieldContext<string>();

  const isRequired = isFieldRequired(
    field.options.form.options.validators,
    field.name,
  );

  const hasErrors = Boolean(field.state.meta.errors?.length);

  const id = useId();

  return (
    <div className={cn('flex flex-col', className)} style={style}>
      {Boolean(label) && (
        <InputLabel hint={hint} htmlFor={id} isRequired={isRequired}>
          {label}
        </InputLabel>
      )}
      <RadioGroup
        id={id}
        value={field.state.value}
        onChange={(event) => {
          field.handleChange(event.target.value);
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            control={<Radio disabled={isDisabled} />}
            label={option.label}
            value={option.value}
            slotProps={{
              typography: {
                className: 'text-sm',
              },
            }}
          />
        ))}
      </RadioGroup>
      {hasErrors ? (
        <ValidationError>
          {unique(field.state.meta.errors.map(({ message }) => message)).join(
            ', ',
          )}
        </ValidationError>
      ) : null}
    </div>
  );
};
